module.exports = __webpack_public_path__ + "static/media/Cplusplus-logo.2824a7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Cplusplus-logo.png
// module id = 489
// module chunks = 0